namespace Matrix.Dashboards {
    export interface Aggregate {
        GroupKeys?: any[];
        Values?: { [key: string]: { [key: string]: any } };
    }
}
